import { conditions } from "helpers";
import { ConditionName, ISinglePlayListProps } from "interfaces";
import { useAppSelector } from "redux-share/hooks";
import { handleVideoOfPlaylistClick } from "redux-share/actions";
import { useState, useEffect, MouseEventHandler } from "react";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const PlayerCard = dynamic(() => import("../playerCard/playerCard"));

const SinglePlayList = ({playList}: ISinglePlayListProps) => {
    const [listScrolled, setListScrolled] = useState<any>([]);

    const { params } = useAppSelector(({ videoData: { params, isComplexDesktop, isComplexPortrait } }) => ({ params, isComplexDesktop, isComplexPortrait }), shallowEqual);
    useAppSelector(({ controller: { isFullScreen } }) => ({ isFullScreen }), shallowEqual);

    useEffect(()=>{
        setListScrolled(playList.videos)
    }, [playList.videos.length])
    
    return (
        <>
            {listScrolled.length ? listScrolled.map((video: any, index:number) => (
                <div
                    key={video.video.id}
                    id={`playList-${video.video.id}`}
                    className={`pl-relative pl-overflow-hidden ${video.video.id === +params.id! && "pl-bg-secondary-200 dark:pl-bg-dark-2"} ${(conditions(ConditionName.isTouchScreen) || conditions(ConditionName.isFullScreen)) && "pl-px-3"}`}
                    style={{ height: conditions(ConditionName.isComplexDesktop) ? 98 : 80 }}
                >
                    <PlayerCard
                        id={video.video.id}
                        tags={video.video.tag}
                        src={video.video.banner}
                        type={video.video.type!}
                        isVideo={false}
                        width={conditions(ConditionName.isComplexDesktop) ? 174 : (conditions(ConditionName.isComplexPortrait) || conditions(ConditionName.isTouchScreenLandscape) || conditions(ConditionName.isFullScreen) || (!conditions(ConditionName.isFullScreen) && !conditions(ConditionName.isParamsPortrait)) ? 142 : window.innerWidth)}
                        height={conditions(ConditionName.isComplexDesktop) ? 98 : (conditions(ConditionName.isComplexPortrait) || conditions(ConditionName.isTouchScreenLandscape) || conditions(ConditionName.isFullScreen) || (!conditions(ConditionName.isFullScreen) && !conditions(ConditionName.isParamsPortrait)) ? 80 : (window.innerWidth * 9) / 16)}
                        duration={video.video.duration}
                        title={video.video.title}
                        isComplexDesktop={conditions(ConditionName.isComplexDesktop)}
                        viewers={video.video.viewers}
                        date={video.video.start_time}
                        onClick={(event: MouseEventHandler<HTMLDivElement>) => video.video.id !== +params.id! && handleVideoOfPlaylistClick(event, playList.id, video.video.id, video.video.type, index)}
                    />
                </div>
            )) : <></>}
        </>
    )
}

export default SinglePlayList;